import React, { useState } from "react";
import { Link } from "react-router-dom";
import { TRACKS, trackQuestions, isAnswered } from "./questions";

export function Shell({ cfg, user, step, onSelect, saveState, onSignOut, children }) {
  const [open, setOpen] = useState(false);
  const t = TRACKS[cfg.track || "ceo"];
  const { sections: SECTIONS, areas: AREAS } = t;
  const qs = trackQuestions(t.key, cfg.respondent_role);
  const answered = qs.filter((q) => isAnswered(cfg.answers?.[q.id])).length;
  const pct = qs.length ? Math.round((answered / qs.length) * 100) : 0;
  const currentQ = qs.find((q) => q.id === step);
  const activeSection = currentQ?.section || (step.startsWith("s:") ? step.slice(2) : null);
  const activeArea = SECTIONS.find((s) => s.key === activeSection)?.area || (step === "summary" ? AREAS[AREAS.length - 1] : null);
  const initials = (user?.full_name || user?.email || "U").split(/[\s@.]+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");
  const pick = (k) => { onSelect(k); setOpen(false); };

  return (
    <div className="fo-app" data-testid="onboarding-shell">
      {open && <div className="fo-scrim" onClick={() => setOpen(false)} />}
      <aside className={`fo-side ${open ? "open" : ""}`} data-testid="onboarding-rail">
        <Link to={t.path} className="fo-brand" data-testid="onboarding-brand">
          <img src="/logos/mark-black.png" alt="" />
          Foundation
          <small>{t.key === "tech" ? "Technical" : "Discovery"}</small>
        </Link>
        <div className="fo-side-org" data-testid="onboarding-org">{cfg.organisation}</div>
        <nav className="fo-rail" aria-label="Sections">
          <button type="button" className={`fo-rail-item ${step === "intro" || step === "welcome" ? "on" : ""}`} onClick={() => pick("intro")} data-testid="rail-intro">
            <span className="idx num">··</span><span>Start</span><span className={`fo-dot ${cfg.respondent_role ? "done" : ""}`} />
          </button>
          {SECTIONS.map((s) => {
            const mine = qs.filter((q) => q.section === s.key);
            const done = mine.filter((q) => isAnswered(cfg.answers?.[q.id])).length;
            return (
              <button key={s.key} type="button" className={`fo-rail-item ${activeSection === s.key ? "on" : ""}`} onClick={() => pick(`s:${s.key}`)} data-testid={`rail-${s.key}`} disabled={!cfg.respondent_role}>
                <span className="idx num">{s.n}</span>
                <span>{s.title}<small className="cnt num" data-testid={`rail-count-${s.key}`}>{done}/{mine.length}</small></span>
                <span className={`fo-dot ${mine.length && done === mine.length ? "done" : ""}`} data-testid={`rail-dot-${s.key}`} />
              </button>
            );
          })}
          <div className="fo-rail-sum">
            <button type="button" className={`fo-rail-item ${step === "summary" ? "on" : ""}`} onClick={() => pick("summary")} data-testid="rail-summary" disabled={!cfg.respondent_role}>
              <span className="idx num">··</span><span>What this builds</span><span className={`fo-dot ${cfg.status === "submitted" ? "done" : ""}`} />
            </button>
          </div>
        </nav>
        <div className="fo-side-foot">
          <div className="fo-progress">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{answered} of {qs.length} answered</span>
              <span className="num" data-testid="onboarding-progress-pct">{pct}%</span>
            </div>
            <span className="fo-bar"><i style={{ width: `${pct}%` }} /></span>
          </div>
          <div className="fo-user">
            <span className="fo-av">{initials}</span>
            <div style={{ minWidth: 0 }}>
              <div className="n">{user?.full_name || "Signed in"}</div>
              <div className="e" data-testid="onboarding-user-email">{user?.email}</div>
            </div>
            <button type="button" onClick={onSignOut} data-testid="onboarding-signout">Sign out</button>
          </div>
        </div>
      </aside>

      <div className="fo-main">
        <header className="fo-top">
          <button type="button" className="fo-menu" aria-label="Open sections" onClick={() => setOpen(true)} data-testid="onboarding-menu">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
          </button>
          <ol className="fo-areas-bar" aria-label="Progress" data-testid="area-progress">
            {AREAS.map((a, i) => (
              <li key={a} className={activeArea === a ? "on" : AREAS.indexOf(activeArea) > i ? "past" : ""} data-testid={`area-${a.toLowerCase()}`}>{a}</li>
            ))}
          </ol>
          <div className={`fo-save ${saveState}`} data-testid="onboarding-save-state">
            <i />
            {saveState === "saving" ? "Saving" : saveState === "error" ? "Not saved, retrying" : cfg.status === "submitted" ? "Submitted" : "Saved"}
          </div>
        </header>
        <main className="fo-wrap">{children}</main>
      </div>
    </div>
  );
}
